/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
// const ARTICLE_ID = '00000000'

export function AppComponent() {
  // Similar to componentDidMount and componentDidUpdate:
  React.useEffect(() => {
    // Update the document title using the browser API
    const script = document.createElement('script')

    script.src = 'https://core.dpa-infocom.net/js/dpa.js'
    script.async = true

    document.body.appendChild(script)
  })

  const params = new URL(window.location).searchParams
  const type = params.get('type')

  if (type === 'senatswahlen') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Senatswahlen</h4>
          {/* <div className='graphicSub'>
               <div>Durchmesser in Zentimeter</div>
             </div> */}

          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='pw_us'
            data-language='de'
            data-standalone='congress'
            data-election-type='senate'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2022/dpa-live-wahlen/midterm-elections/senatswahlen/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://embed.dpa-electionslive.com/customers/midterm-usa2022/aws/tamedia/html/index.html'
            data-path='https://embed.dpa-electionslive.com/pw_us/'
          />
        </div>
      </div>
    )
  }

  if (type === 'repraesentantenhaus') {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ta text'>
          <h4 className='graphicTitle'>Repräsentantenhaus</h4>
          {/* <div className='graphicSub'>
               <div>Durchmesser in Zentimeter</div>
             </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='iframe-dyn'
            data-competition-id='pw_us'
            data-language='de'
            data-standalone='congress'
            data-election-type='house'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2022/dpa-live-wahlen/midterm-elections/repraesentantenhaus/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://embed.dpa-electionslive.com/customers/midterm-usa2022/aws/tamedia/html/index.html'
            data-path='https://embed.dpa-electionslive.com/pw_us/'
          />
        </div>
      </div>
    )
  }

  return null
}
